import PropTypes from 'prop-types';

import { SOURCE_YOUTUBE, SOURCE_VIMEO, SOURCE_OTHER } from './VideoPlayerEditor.constants';

export const VideoPlayerSourcePropType = PropTypes.oneOf([
  SOURCE_YOUTUBE,
  SOURCE_VIMEO,
  SOURCE_OTHER,
]);
